import { marked } from 'marked';

/** Presentation of the report's existing section contract, never intent routing. */
export function reportSections(content: string): { body: string; suggestion: string | null; after: string } {
  const tokens = marked.lexer(content);
  const start = tokens.findIndex(token => {
    if (token.type !== 'heading' && token.type !== 'paragraph') return false;
    const title = token.text.trim().replace(/^\*\*(.*?)\*\*:?$/, '$1').replace(/:$/, '').trim();
    return /^(suggested )?next step$/i.test(title);
  });
  if (start < 0) return { body: content, suggestion: null, after: '' };
  const title = tokens[start];
  const end = tokens.findIndex((token, index) => index > start && token.type === 'heading'
    && (title.type !== 'heading' || token.depth <= title.depth));
  const stop = end < 0 ? tokens.length : end;
  const raw = (from: number, to: number) => tokens.slice(from, to).map(token => token.raw).join('');
  return { body: raw(0, start), suggestion: raw(start + 1, stop), after: raw(stop, tokens.length) };
}
